<template>
  <match-list scrollbar-name="home-overview" :key="this.$route.path + isActive('page', 'main') + isActive('page', 'sports') + isActive('page', 'upcoming') + $i18n.locale"></match-list>
</template>

<script>
import MatchList from '@/components/live/overview/List'

export default {
  components: {
    MatchList
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sports/main/live/View.vue